import { FileText, Package, AlertTriangle } from 'lucide-react';

const SBOM_DATA = [
  { asset: 'srv-web-01', software: 'nginx', version: '1.24.0', vulns: 2, lastScan: '2026-05-12 08:00' },
  { asset: 'srv-web-01', software: 'openssl', version: '3.1.2', vulns: 0, lastScan: '2026-05-12 08:00' },
  { asset: 'srv-db-01', software: 'postgresql', version: '15.4', vulns: 3, lastScan: '2026-05-12 07:30' },
  { asset: 'srv-app-01', software: 'nodejs', version: '20.11.0', vulns: 1, lastScan: '2026-05-12 07:30' },
  { asset: 'srv-app-01', software: 'express', version: '4.18.2', vulns: 0, lastScan: '2026-05-12 07:30' },
  { asset: 'ws-finance-12', software: 'python3', version: '3.11.5', vulns: 4, lastScan: '2026-05-11 22:00' },
  { asset: 'fw-corp-01', software: 'iptables', version: '1.8.9', vulns: 0, lastScan: '2026-05-11 18:00' },
  { asset: 'srv-dc-01', software: 'samba', version: '4.18.6', vulns: 2, lastScan: '2026-05-11 18:00' },
];

const SbomRecords = () => (
  <div className="p-6 space-y-6">
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-white">SBOM Records</h1>
      <p className="text-sm text-gray-500 mt-1">
        Software Bill of Materials for vulnerability tracking · PRD: ASSET-02 (Section 7.6)
      </p>
    </div>

    <div className="bg-gray-900 border border-gray-700/50 rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <FileText className="w-5 h-5 text-cyan-400" />
          <h2 className="text-lg font-semibold text-white">Software Inventory</h2>
        </div>
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-cyan-500/20 text-cyan-400 border border-cyan-500/30">
          Coming Soon
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-gray-500 uppercase text-xs border-b border-gray-700/50">
              <th className="text-left py-3 pr-4 font-medium">Asset</th>
              <th className="text-left py-3 pr-4 font-medium">Software</th>
              <th className="text-left py-3 pr-4 font-medium">Version</th>
              <th className="text-left py-3 pr-4 font-medium">Vulnerabilities</th>
              <th className="text-left py-3 font-medium">Last Scanned</th>
            </tr>
          </thead>
          <tbody className="text-gray-400">
            {SBOM_DATA.map((row, i) => (
              <tr key={i} className="border-b border-gray-800/50 hover:bg-gray-800/30 transition-colors">
                <td className="py-3 pr-4">
                  <div className="flex items-center gap-2">
                    <Package className="w-3.5 h-3.5 text-gray-600" />
                    <span className="text-white font-medium">{row.asset}</span>
                  </div>
                </td>
                <td className="py-3 pr-4 font-mono text-xs">{row.software}</td>
                <td className="py-3 pr-4 font-mono text-xs text-gray-500">{row.version}</td>
                <td className="py-3 pr-4">
                  {row.vulns > 0 ? (
                    <span className="inline-flex items-center gap-1.5 text-red-400">
                      <AlertTriangle className="w-3.5 h-3.5" />
                      <span className="font-mono font-medium">{row.vulns}</span>
                    </span>
                  ) : (
                    <span className="text-emerald-400 font-mono">0</span>
                  )}
                </td>
                <td className="py-3 font-mono text-xs text-gray-500">{row.lastScan}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default SbomRecords;
